import { render, staticRenderFns } from "./add_send_movement.vue?vue&type=template&id=194921d9"
import script from "./add_send_movement.vue?vue&type=script&lang=js"
export * from "./add_send_movement.vue?vue&type=script&lang=js"
import style0 from "./add_send_movement.vue?vue&type=style&index=0&id=194921d9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports